<template>
  <div class="bg-white" :class="{ 'w-full': mtmUserConfirmed }">
    <template v-if="!mtmUserConfirmed">
      <div
        v-if="!mtmUserLoggedIn"
        class="input-wrapper relative mb-5 rounded-sm"
        :class="{ focus: focusStatus === 'account' }"
      >
        <input
          class="w-full h-12 pl-6 outline-none"
          type="email"
          autofocus
          v-model="account"
          :placeholder="$t('homePage.enter_Scanatic_account')"
          @click="focusStatus = 'account'"
        />
        <img
          v-show="false"
          class="scan absolute"
          src="../../../assets/common/scan.svg"
          alt="scan"
        />
      </div>
      <div v-else class="account">{{ mtmUser }}</div>
      <div class="input-wrapper relative rounded-sm" :class="{ focus: focusStatus === 'password' }">
        <input
          class="w-full h-12 pl-6 outline-none"
          :type="inputType"
          v-model="password"
          :placeholder="$t('homePage.password')"
          @click="focusStatus = 'password'"
        />
        <img
          v-if="isHide"
          class="eye-icon absolute"
          src="../../../assets/common/eye.svg"
          @click="isHide = !isHide"
        />
        <img
          v-else
          class="eye-icon absolute"
          src="../../../assets/common/black-eye.svg"
          @click="isHide = !isHide"
        />
      </div>
      <c-button
        :confirmed-status="confirmedStatus"
        class="relative mx-auto mt-12 mb-20"
        @click="login"
      >
        <span>{{ loginBtnText }}</span>
      </c-button>
      <div v-if="error" class="error-msg h-5 flex justify-center w-full">
        <img class="mr-3" src="../../../assets/DefaultCloudzet/basic-confused.svg" />
        <span class="text-xs">{{ error }}</span>
      </div>
    </template>
    <template v-else>
      <div class="account">{{ mtmUser }}</div>
      <menu-item
        v-for="item in mtmItems"
        class="mx-auto my-0"
        :key="item.key"
        :item="item"
        @click="$emit(item.event)"
      />
    </template>
  </div>
</template>

<script>
import CButton from '@/components/common/CButton.vue';
import logOut from '@/assets/common/log-out.svg';
import MenuItem from './MenuItem.vue';

export default {
  components: {
    CButton,
    MenuItem,
  },
  props: {
    mtmUserLoggedIn: Boolean,
    mtmUserConfirmed: Boolean,
    needConfirm: Boolean,
    error: String,
    mtmUser: String,
  },
  data: vm => {
    return {
      account: vm.mtmUser || '',
      password: '',
      isHide: true,
      focusStatus: 'account',
      mtmItems: [
        {
          key: 'mtmLogOut',
          img: logOut,
          name: vm.$t('homePage.logout'),
          target: '',
          title: vm.$t('homePage.store_settings'),
          event: 'logout',
        },
      ],
    };
  },
  computed: {
    inputType() {
      return this.isHide ? 'password' : 'text';
    },
    confirmedStatus() {
      return this.password.length > 3 && !!this.account;
    },
    loginBtnText() {
      return this.needConfirm ? this.$t('login.verify') : this.$t('homePage.login');
    },
  },
  methods: {
    login() {
      if (!this.confirmedStatus) return;

      const event = this.needConfirm ? 'confirm' : 'login';
      const account = this.needConfirm ? this.mtmUser : this.account;
      this.$emit(event, { account, password: this.password });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  color: var(--primary-color);
}

.input-wrapper {
  @apply bg-contain bg-no-repeat;
  width: 309px;
  background-color: #f5f5f5;

  &.focus {
    @apply bg-white;
    background-image: url('../../../assets/common/rectangle-1334.svg');
  }

  input {
    width: 80%;
    background: none;
  }
}

.account {
  @apply .relative .mb-5 .rounded-sm text-center;
  font-size: 12px;
  color: rgba(38, 38, 38, 0.6);
}

.error-msg {
  color: #d12c2d;
}

.eye-icon,
.scan {
  top: 50%;
  right: 21px;
  transform: translateY(-50%);
}
</style>
